
import { mapGetters } from 'vuex';
export default {
	components: {
		breadcrumbs				: () => import('../../../components/pages/breadcrumbs.vue'),
		vcDynamicLink			: () => import('../../../components/pages/dynamic-link.vue'),
		dynamicComponentLoader	: () => import('../../../components/pages/dynamic-component-loader.vue'),
	},
	async mounted() {
	},
	computed: {
		...mapGetters({
			getterTranslates 	: 'getterTranslates',
			getterStoreLang	 	: 'getterStoreLang',
			getterNavigations	: 'getterNavigations'
		}),
		getNavigationAcount(){
			return ( this.getterNavigations?.account || [] );
		},
	},
};
